import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { createBatchAnimation } from './createBatchAnimation';

let businessCardTriggers: ScrollTrigger[] = [];

export function refreshBusinessCardAnimations(grid: HTMLElement): void {
  const cards = Array.from(grid.querySelectorAll<HTMLElement>('.animate-fade'));

  // Kill ST instances for current grid cards and any zombie instances
  // (elements previously in the grid that Vue has since removed from the DOM)
  ScrollTrigger.getAll()
    .filter(
      (st) =>
        (st.trigger && cards.includes(st.trigger as HTMLElement)) ||
        (st.trigger && !document.contains(st.trigger)),
    )
    .forEach((st) => st.kill());
  businessCardTriggers = [];

  if (cards.length === 0) return;

  businessCardTriggers = createBatchAnimation({
    selector: cards,
    initialState: {
      autoAlpha: 0,
      y: 25,
    },
  });

  ScrollTrigger.refresh();
}
